export default "__VITE_ASSET__DOGeBzX6__"